/**
 * The renderer's version, which is part of every S3 key and every queue message.
 *
 * Lives here, alone, because three things need it and none of them may disagree:
 * the generator (which writes cards), the queue contract (which deduplicates
 * work per version), and the infrastructure (which lays out the bucket and the
 * distribution's behaviours). The renderer owns the number — it is the thing
 * whose output changes — so infra reads it from here rather than declaring a
 * second copy that a layout change could leave behind.
 *
 * ## When to bump it
 *
 * When a layout or semantic change makes existing cards *inappropriate*, not
 * merely different. An `og-v2` ships alongside `og-v1` without mutating it, so
 * a post embedding a card from last month keeps rendering the card it embedded
 * — the image is fetched by URL for as long as the post lives, and the URL is
 * therefore what has to pin the design.
 *
 * The corollary is the reason to be reluctant: a bump regenerates every card
 * that anyone asks for again, at full Hub cost, and doubles what the bucket
 * holds. It is a deliberate migration, not a version stamp to keep current.
 */
export const RENDERER_VERSION = "og-v1";
